export enum E_FUNCTIONALITY {
  btn_create_order = "btn_create_order",
  create_purchase_order = "create_purchase_order",
  edit_inline_purchase_order = "edit_inline_purchase_order",
  edit_modal_purchase_order = "edit_modal_purchase_order",
  request_edit_purchase_order = "request_edit_purchase_order",
  submit_for_validation_purchase_order = "submit_for_validation_purchase_order",
  save_purchase_order = "save_purchase_order",
  cancel_purchase_order = "cancel_purchase_order",
  reject_purchase_order = "reject_purchase_order",
  generate_pdf_purchase_order = "generate_pdf_purchase_order",
  manage_purchase_order = "manage_purchase_order",
  validate_purchase_order = "validate_purchase_order",
  make_editable_purchase_order = "make_editable_purchase_order",
  menu_order = "menu_order",
  menu_purchase_order = "menu_purchase_order",
  menu_stock = "menu_stock",
  menu_fcd = "menu_fcd",
  menu_pdms = "menu_pdms",
  menu_reporting_pdms = "menu_reporting_pdms",
  btn_delete_production_ticket_scan_pdms_scan = "btn_delete_production_ticket_scan_pdms_scan",
  btn_bulk_import_production_ticket_scan_pdms_scan = "btn_bulk_import_production_ticket_scan_pdms_scan",
  menu_setting = "menu_setting",
  menu_costing_sheet_sample_references= "menu_costing_sheet_sample_references",

  //pdms
  //order
  accessory_ticket_pdms_order = "accessory_ticket_pdms_order",
  btn_create_pdms_order = "btn_create_pdms_order",
  btn_create_wa_sheet_details_pdms_order = "btn_create_wa_sheet_details_pdms_order",
  production_ticket_pdms_order = "production_ticket_pdms_order",
  clothes_ticket_pdms_order = "clothes_ticket_pdms_order",
  btn_edit_wa_sheet_details_pdms_order = "btn_edit_wa_sheet_details_pdms_order",
  sub_menu_pdms_order = "sub_menu_pdms_order",
  btn_edit_smv_pdms_order = "btn_edit_smv_pdms_order",
  sub_menu_yarn_requirement_allocation="sub_menu_yarn_requirement_allocation",
  //scan
  btn_rework_pdms_scan = "btn_rework_pdms_scan",
  btn_reject_pdms_scan = "btn_reject_pdms_scan",
  make_editable_scan_ticket_pdms_scan = "make_editable_scan_ticket_pdms_scan",
  sub_menu_pdms_scan = "sub_menu_pdms_scan",
  sub_menu_pdms_ticket_details = "sub_menu_pdms_ticket_details",
  sub_menu_pdms_missing_pieces = "sub_menu_pdms_missing_pieces",
  sub_menu_pdms_left_over = "sub_menu_pdms_left_over",
  btn_create_pdms_left_over = "btn_create_pdms_left_over",
  sub_menu_pdms_quantity_taken = "sub_menu_pdms_quantity_taken",
  btn_create_pdms_quantity_taken = "btn_create_pdms_quantity_taken",
  btn_return_pdms_quantity_taken = "btn_return_pdms_quantity_taken",

  //reporting_pdms
  sub_menu_reporting_pdms_order_situation = "sub_menu_reporting_pdms_order_situation",
  sub_menu_reporting_pdms_daily_report_machine = "sub_menu_reporting_pdms_daily_report_machine",
  sub_menu_reporting_pdms_daily_report_order = "sub_menu_reporting_pdms_daily_report_order",
  sub_menu_reporting_pdms_daily_report_by_section = "sub_menu_reporting_pdms_daily_report_by_section",

  //Setting
  menu_setting_users= "menu_setting_users",
  menu_setting_managements= "menu_setting_managements",
  menu_setting_user= "menu_setting_user",
  menu_setting_department= "menu_setting_department",
  menu_setting_role= "menu_setting_role",
  menu_setting_functionality= "menu_setting_functionality",
  menu_setting_supplier= "menu_setting_supplier",
  menu_setting_gestion_machine= "menu_setting_gestion_machine",
  menu_setting_gestion_yarn_composition= "menu_setting_gestion_yarn_composition",
  menu_setting_gestion_yarn_count= "menu_setting_gestion_yarn_count",

  //Purchaser Global
  menu_purchaser_global="menu_purchaser_global",

  //warehouse
  //sub menu
  sub_menu_inventory= "sub_menu_inventory",
  sub_menu_pending_invoice= "sub_menu_pending_invoice",
  sub_menu_received_invoice= "sub_menu_received_invoice",
  sub_menu_delivery_note= "sub_menu_delivery_note",

  //Inventory
  sub_menu_warehouse_yarn= "sub_menu_warehouse_yarn",
  sub_menu_warehouse_accessory= "sub_menu_warehouse_accessory",
  sub_menu_warehouse_garment= "sub_menu_warehouse_garment",
  sub_menu_warehouse_fcd="sub_menu_warehouse_fcd",
  sub_menu_warehouse_adjustments= "sub_menu_warehouse_adjustments",

  //delivery note
  sub_menu_delivery_note_yarn= "sub_menu_delivery_note_yarn",
  sub_menu_delivery_note_accessory= "sub_menu_delivery_note_accessory",
  sub_menu_delivery_note_fcd= "sub_menu_delivery_note_fcd",
  sub_menu_delivery_note_garment= "sub_menu_delivery_note_garment",

  //Inventory button
  //Yarn & Accessory
  btn_warehouse_inventory_upload="btn_warehouse_inventory_upload",
  btn_warehouse_inventory_create_request="btn_warehouse_inventory_create_request",
  btn_warehouse_inventory_create_stock_manual="btn_warehouse_inventory_create_stock_manual",
  btn_warehouse_inventory_create_new_stock="btn_warehouse_inventory_create_new_stock",
  btn_warehouse_inventory_manage_tags="btn_warehouse_inventory_manage_tags",
  btn_warehouse_inventory_daily_report="btn_warehouse_inventory_daily_report",
  btn_warehouse_inventory_export_all="btn_warehouse_inventory_export_all",

  //btn
  btn_inventory_yarn_details_update= "btn_inventory_yarn_details_update",
  btn_inventory_accessory_details_update= "btn_inventory_accessory_details_update",
  btn_inventory_yarn_adjust_quantity= "btn_inventory_yarn_adjust_quantity",
  btn_inventory_accessory_adjust_quantity= "btn_inventory_accessory_adjust_quantity",

  //fcd inventory
  btn_warehouse_fcd_create_request= "btn_warehouse_fcd_create_request",

  //inventory tabs
  sub_menu_inventory_warehouse= "sub_menu_inventory_warehouse",
  sub_menu_inventory_booking_warehouse= "sub_menu_inventory_booking_warehouse",
  sub_menu_inventory_stock_issues_warehouse= "sub_menu_inventory_stock_issues_warehouse",
  sub_menu_inventory_stock_return_warehouse= "sub_menu_inventory_stock_return_warehouse",
  sub_menu_inventory_stock_transfert_warehouse= "sub_menu_inventory_stock_transfert_warehouse",

  //inventory fcd
  sub_menu_inventory_fcd_tab_fcd_issues= "sub_menu_inventory_fcd_tab_fcd_issues",
  sub_menu_inventory_fcd_tab_fcd_return= "sub_menu_inventory_fcd_tab_fcd_return",

  //inventory adjustements
  sub_menu_inventory_adjust_tab_yarn= "sub_menu_inventory_adjust_tab_yarn",
  sub_menu_inventory_adjust_tab_accessory= "sub_menu_inventory_adjust_tab_accessory",
  btn_inventory_adjustement_reject= "btn_inventory_adjustement_reject",
  btn_inventory_adjustement_cancel= "btn_inventory_adjustement_cancel",
  btn_inventory_adjustement_approve= "btn_inventory_adjustement_approve",

  //Delivery note tabs
  //Yarn & Accessory
  sub_menu_delivery_note_tab_delivery_note= "sub_menu_delivery_note_tab_delivery_note",
  sub_menu_delivery_note_tab_booking= "sub_menu_delivery_note_tab_booking",
  sub_menu_delivery_note_tab_stock_issues= "sub_menu_delivery_note_tab_stock_issues",
  sub_menu_delivery_note_tab_stock_return= "sub_menu_delivery_note_tab_stock_return",
  sub_menu_delivery_note_tab_stock_transfert= "sub_menu_delivery_note_tab_stock_transfert",

  //Fcd
  sub_menu_delivery_note_fcd_tab_delivery_note= "sub_menu_delivery_note_fcd_tab_delivery_note",
  sub_menu_delivery_note_fcd_tab_fcd_issues= "sub_menu_delivery_note_fcd_tab_fcd_issues",
  sub_menu_delivery_note_fcd_tab_received= "sub_menu_delivery_note_fcd_tab_received",
  sub_menu_delivery_note_fcd_tab_arrived= "sub_menu_delivery_note_fcd_tab_arrived",
  sub_menu_delivery_note_fcd_tab_fcd_to_warehouse= "sub_menu_delivery_note_fcd_tab_fcd_to_warehouse",
  sub_menu_delivery_note_fcd_tab_received_from_fcd= "sub_menu_delivery_note_fcd_tab_received_from_fcd",
  sub_menu_delivery_note_fcd_tab_stock_from_fcd= "sub_menu_delivery_note_fcd_tab_stock_from_fcd",

  //btn delivery note
  btn_delivery_note_update= "btn_delivery_note_update",
  btn_delivery_note_reject= "btn_delivery_note_reject",
  btn_delivery_note_cancel= "btn_delivery_note_cancel",
  btn_delivery_note_approve= "btn_delivery_note_approve",
  btn_delivery_note_generate_pdf= "btn_delivery_note_generate_pdf",
  btn_delivery_note_ready= "btn_delivery_note_ready",
  btn_delivery_note_deliver= "btn_delivery_note_deliver",
  btn_delivery_note_show_delivery_history= "btn_delivery_note_show_delivery_history",
  btn_delivery_note_receive= "btn_delivery_note_receive",
  btn_delivery_note_show_reception_history= "btn_delivery_note_show_reception_history",
  btn_delivery_note_make_issue= "btn_delivery_note_make_issue",

 //btn fcd delivery note
  btn_delivery_note_fcd_update= "btn_delivery_note_fcd_update",
  btn_delivery_note_fcd_reject= "btn_delivery_note_fcd_reject",
  btn_delivery_note_fcd_cancel= "btn_delivery_note_fcd_cancel",
  btn_delivery_note_fcd_approve= "btn_delivery_note_fcd_approve",
  btn_delivery_note_fcd_generate_pdf= "btn_delivery_note_fcd_generate_pdf",
  btn_delivery_note_fcd_deliver= "btn_delivery_note_fcd_deliver",
  btn_delivery_note_fcd_show_delivery_history= "btn_delivery_note_fcd_show_delivery_history",
  btn_delivery_note_fcd_received_mark_as_arrived= "btn_delivery_note_fcd_received_mark_as_arrived",
  btn_delivery_note_fcd_arrived_create_fcd_return= "btn_delivery_note_fcd_arrived_create_fcd_return",
  btn_delivery_note_fcd_return_mark_as_arrived= "btn_delivery_note_fcd_return_mark_as_arrived",
  btn_delivery_note_fcd_return_integrate_to_stock= "btn_delivery_note_fcd_return_integrate_to_stock",

  //pending invoice
  sub_menu_pending_invoice_tab_yarn= "sub_menu_pending_invoice_tab_yarn",
  sub_menu_pending_invoice_tab_accessory= "sub_menu_pending_invoice_tab_accessory",
  btn_pending_invoice_mark_as_arrived= "btn_pending_invoice_mark_as_arrived",
  btn_pending_invoice_export_receiving_report= "btn_pending_invoice_export_receiving_report",
  btn_pending_invoice_export_swatch_list= "btn_pending_invoice_export_swatch_list",
  btn_pending_invoice_save= "btn_pending_invoice_save",
  btn_pending_invoice_download_packing_file= "btn_pending_invoice_download_packing_file",


  //received invoice
  sub_menu_received_invoice_tab_yarn= "sub_menu_received_invoice_tab_yarn",
  sub_menu_received_invoice_tab_accessory= "sub_menu_received_invoice_tab_accessory",
  
}
